import { Box, styled } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { nimbleTheme } from 'theme';
import { TooltipButtonClickTrigger } from 'sharedComponents/Buttons/TooltipButtonClickTrigger';
import { CopyLinkInputProps } from './types';

export const CopyLinkInput: React.FC<CopyLinkInputProps> = ({
  link,
  maxWidth,
  dataTestId,
  linkDataTestId,
  copyButtonDataTestId,
  sx,
}) => {
  const handleCopyClick = () => {
    return navigator.clipboard.writeText(link);
  };

  return (
    <Container data-testid={dataTestId} sx={{ maxWidth, ...sx }}>
      <LinkInput
        value={link}
        readOnly
        size={link.length}
        data-testid={linkDataTestId || 'copy-link-input'}
      />
      <TooltipButtonClickTrigger
        onClick={handleCopyClick}
        variant="text"
        dataTestId={copyButtonDataTestId || 'copy-link-button'}
        startIcon={<ContentCopyIcon fontSize="small" />}
        tooltipText="Copied!"
        buttonSx={{
          borderLeft: `1px solid ${nimbleTheme.palette.gray.darker}`,
          borderRadius: 0,
          color: nimbleTheme.palette.text.primary,
          fontSize: 'body1.fontSize',
          fontWeight: nimbleTheme.typography.fontWeightMediumBold,
          lineHeight: nimbleTheme.spacing(3),
          padding: nimbleTheme.spacing(1.5),
          flex: '0 0 auto',
        }}
      >
        Copy
      </TooltipButtonClickTrigger>
    </Container>
  );
};

const Container = styled(Box)({
  alignItems: 'center',
  border: `1px solid ${nimbleTheme.palette.gray.darker}`,
  borderRadius: nimbleTheme.spacing(1),
  display: 'flex',
  width: 'fit-content',
});

const LinkInput = styled('input')({
  flex: '1 1 0',
  minWidth: 0,
  border: 'none',
  outline: 'none',
  backgroundColor: 'transparent',
  marginLeft: nimbleTheme.spacing(1),
  padding: `${nimbleTheme.spacing(1)} 0`,
  fontSize: nimbleTheme.typography.body1.fontSize,
  fontFamily: nimbleTheme.typography.fontFamily,
});
